import { __read } from 'tslib';
import { useState, useRef, useEffect } from 'react';
import { useOnScreen } from './useOnScreen.js';

/**
 * Хук для обработки изменений видимости элемента с использованием IntersectionObserver.
 *
 * @param {IProps} props - Свойства для хука.
 * @param {() => void} [props.onVisibleOnce] - Функция обратного вызова, вызываемая один раз, когда элемент становится видимым один раз.
 * @param {IntersectionObserverInit} [props.options] - Необязательный объект конфигурации для IntersectionObserver.
 * @returns {{ ref: React.RefObject<HTMLElement> }} - Объект, содержащий ref для прикрепления к элементу.
 */
var useOnVisibleOnce = function (_a) {
    var options = _a.options, onVisibleOnce = _a.onVisibleOnce;
    var _b = __read(useOnScreen(options), 2), ref = _b[0], isVisible = _b[1];
    var _c = __read(useState(false), 2), isShownOnce = _c[0], setIsShownOnce = _c[1];
    var onVisibleOnceRef = useRef(onVisibleOnce);
    /** Выносим обработчики в рефы, чтобы не тригерить эффект при отсутствии мемоизации */
    onVisibleOnceRef.current = onVisibleOnce;
    useEffect(function () {
        var _a;
        if (isVisible && !isShownOnce) {
            setIsShownOnce(true);
            (_a = onVisibleOnceRef.current) === null || _a === void 0 ? void 0 : _a.call(onVisibleOnceRef);
        }
    }, [isVisible, isShownOnce]);
    return {
        ref: ref,
    };
};

export { useOnVisibleOnce };
//# sourceMappingURL=useOnVisibleOnce.js.map
